
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth-handler",
      function () {
        return require("private-next-pages/auth-handler/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth-handler"])
      });
    }
  